import React, { FC, PropsWithChildren } from 'react';
import { Typography } from '../../typography';
import classes from './confirmation-card-title.module.scss';

export const ConfirmationCardTitle: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={classes.root}>
      <Typography variant="h2">{children}</Typography>
    </div>
  );
};
